// extracted by mini-css-extract-plugin
export default {"authLayout":"AuthLayout_authLayout__vGebf","backButton":"AuthLayout_backButton__sPvUe"};